// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"1069eb39","343":"44899443"}[chunkId] + ".chunk.css";
};